import {createNeutron} from '../packages/neutron';

export const unitSignal = createNeutron<string>();
